module.exports = __webpack_public_path__ + "img/shaizi2.74a39248.png";